import { VICTRON_BASE_URL } from '@constants/common';

export const DOCUMENT_UPLOAD_PATH_PREFIX = '/upload/documents/';

const ABSOLUTE_URL_REGEX = /^https?:\/\//i;

export const isDocumentUploadUrl = (url: string) => url.includes(DOCUMENT_UPLOAD_PATH_PREFIX);

export const getVictronDocumentUrl = (url: string) => {
    if (ABSOLUTE_URL_REGEX.test(url)) {
        return url;
    }

    return `${VICTRON_BASE_URL.replace(/\/$/, '')}/${url.replace(/^\/+/, '')}`;
};

export const getDocumentDownloadPath = (url: string) =>
    `documents/download/?url=${encodeURIComponent(getVictronDocumentUrl(url))}`;